module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C188"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowle#page_vii"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C189"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduc#page_1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_One___Co#page_11"
    }
  }, [_vm._v("ONE. “Convenient to the New York Market”: Feeding New York City in the Early National Period, 1786–1830")])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Two____T#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWO. “The Glory of a Plenteous Land”: The Transformation of New York’s Food Supply, 1825–1865")])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Three___#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THREE. “Monuments of Municipal Malfeasance”: The Flip Side of Dietary Abundance, 1825–1865")])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Four___T#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOUR. “To See and Be Seen”: Restaurants and Public Culture, 1825–1865")])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Five___N#page_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE. “No Place More Attractive than Home”: Domesticity and Consumerism, 1830–1880")])]), _vm._v(" "), _c('p', {
    staticClass: "C189"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Six___Th#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIX. “The Empire of Gastronomy”: New York and the World, 1850–1890")])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Conclusi#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion. From the Broadway Shambles to New Amsterdam Market")])])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Notes#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C188"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Index#page_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb521b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 66
// module chunks = 0